import React from 'react';
import { Check } from 'lucide-react';
import { UI_TEXT } from '../../config/ui-text';

const BUTTON_CLASS = 'w-full text-left px-4 py-3 rounded-lg border-2 transition-all duration-200';
const SELECTED_CLASS = 'border-blue-500 bg-blue-50 text-blue-900';
const UNSELECTED_CLASS =
  'border-gray-300 bg-white text-gray-900 hover:border-gray-400 hover:bg-gray-50';
const CHECK_BADGE_CLASS = 'w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center';
const CHECK_ICON_CLASS = 'w-3 h-3 text-white';

interface Props {
  selected: boolean;
  onToggle: () => void;
}

/**
 * The built-in "None of these" on a multi-select (spec 111-01 §8), drawn like the "Other" box.
 * Never disabled by the cap: choosing it replaces every other pick.
 */
const NoneOfTheseChoice: React.FC<Props> = ({ selected, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    aria-pressed={selected}
    className={`${BUTTON_CLASS} ${selected ? SELECTED_CLASS : UNSELECTED_CLASS}`}
  >
    <div className="flex items-center justify-between">
      <span>{UI_TEXT.HUMAN_SURVEY.SESSION.CHOICES.NONE_OF_THESE}</span>
      {selected && (
        <div className={CHECK_BADGE_CLASS}>
          <Check className={CHECK_ICON_CLASS} />
        </div>
      )}
    </div>
  </button>
);

export default NoneOfTheseChoice;
